export default __webpack_public_path__ + "static/yandex_eda-c0a55edfd0b5390763a8287e5d025100.png";